import { render, staticRenderFns } from "./LoginChallengeInDialog.vue?vue&type=template&id=20280c58&scoped=true"
import script from "./LoginChallengeInDialog.vue?vue&type=script&lang=js"
export * from "./LoginChallengeInDialog.vue?vue&type=script&lang=js"
import style0 from "./LoginChallengeInDialog.vue?vue&type=style&index=0&id=20280c58&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20280c58",
  null
  
)

export default component.exports